/*
 * @Description:
 * @Version: 2.0
 * @Author: PengPai
 * @Date: 2022-04-30 11:43:20
 * @LastEditors: PengPai
 * @LastEditTime: 2022-11-29 09:28:37
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store/store.js'
// import CKEditor from '@ckeditor/ckeditor5-vue'
import 'babel-polyfill'
import '@/styles/index.scss' // global css
import { checkSSO } from '@/utils/checksso'
import { login } from '@/utils/index'
import wx from 'weixin-js-sdk' // 引入
Vue.prototype.wx = wx
Vue.config.productionTip = false
Vue.use(ElementUI)
// Vue.use(CKEditor)

// Vue.config.errorHandler = function (err, vm, info) {
//   let path = vm.$route.name
//   let {
//     message // 异常信息
//   } = err
//   let type
//   var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
//   if (userAgent.indexOf('Opera') > -1) {
//     type = 'Opera'
//   } else if (userAgent.indexOf('Firefox') > -1) {
//     type = 'FF'
//   } else if (userAgent.indexOf('Chrome') > -1) {
//     type = 'Chrome'
//   } else if (userAgent.indexOf('Safari') > -1) {
//     type = 'Safari'
//   } else if (userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 && !userAgent.indexOf('Opera') > -1) {
//     type = 'IE'
//   }
//   let data = {
//     message: message,
//     info: type,
//     path: path,
//     errortype: 1
//   }
//   $.ajax({
//     type: 'post',
//     url: 'https://card.heidutech.com/api/coon/loginsert',
//     data: data,
//     dataType: 'json',
//     success: function (res) {
//       console.log('上报成功')
//     }
//   })

//   // 逻辑处理
// }
router.beforeEach((to, from, next) => {
  debugger
  // if (localStorage.getItem('redirect_url') && (to.path != '/' || to.path != '/Home')) {
  //   let url = localStorage.getItem('redirect_url')
  //   localStorage.removeItem('redirect_url')
  //   window.location.href = url
  //   return
  // }
  try {
    if (to.meta.requiresAuth) { // 需要登录的页面
      if (!localStorage.getItem('user') || !JSON.parse(localStorage.getItem('user')).No) {
        next('/Login')
        // login()
      } else {
        if (to.path === '/') {
          if (!isNaN(to.query.kid)) {
            next({path: '/Detail?kId=' + to.path.split('/')[1], replace: true}) // 访问下一个页面
          }
        } else {
          next()
        }
      }
      // checkSSO('8tCZa6AcqjBmErNA').then(result => {

      // })
      // if (store.state.bAuth) { // 已登录
      //   next() // 访问下一个页面
      // } else { // 未登录
      //   alert('请先登录')
      //   login() // 回到登录界面
      // }
    } else {
      next()
    }

    // if (to.path != '/' && to.path.split('/').length === 2 && !isNaN(to.path.split('/')[1])) {
    //   next({path: '/Detail?kId=' + to.path.split('/')[1], replace: true}) // 访问下一个页面
    // } else {

    // }
  } catch (error) {

  }

  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
Vue.config.devtools = true



// WEBPACK FOOTER //
// ./src/main.js